var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-footer"},[_c('b-nav',{attrs:{"align":"center"}},[_c('b-nav-item',{attrs:{"href":"https://rabbiitfirm.com/"}},[_vm._v("Home")]),_c('b-nav-item',{attrs:{"href":"https://rabbiitfirm.com/guest-posting"}},[_vm._v("Services")]),_c('b-nav-item',{attrs:{"href":"https://rabbiitfirm.com/contact"}},[_vm._v("Contact Us")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }